module.exports = __webpack_public_path__ + "fonts/lucidagrande.cab01315.ttf";